// © Microsoft Corporation. All rights reserved.
import { childCookieName } from "@msnews/experiences-constants";
import { getCookieCore, tryParseJson } from "@msnews/core-helper";
/**
 * Common helper function to get the audience mode from the cookie string.
 * @param cookieString - The cookie string to parse for the aace/child mode value.
 * @param clientSettings - The client settings from PCS
 * @returns The audience mode calculated from the cookies.
 */
export function getAudienceModeFromCookies(cookieString, clientSettings) {
    // Set Kids audience mode based on conditions below, otherwise use PCS provided Audience mode.
    let audienceMode;
    // There are two auth endpoints in production, at the time of this comment. One is a Prime based auth-endpoint (that is still being used by few Peregrine canvases)
    // and the second is a dedicated Peregrine endpoint hosted by OneService. In both endpoints, AACE cookie is dropped independent of the child cookie.
    // In Prime based auth endpoint, if the account is identified as Child account, a Child cookie is being dropped. In practice, we see that the value of that cookie is 0,
    // but the cookie is only dropped for Child accounts, so it's enough to check for just the presence of that cookie.
    // In OneService based auth endpoint (that is used by most of the Peregrine canvases), if an account is identified as Child account, auth service drops an AACE cookie
    // with a value of {"child": 1} for child accounts and {"child": 0} otherwise.
    // Until we move over to the newer (1S based) auth endpoint, we still have to honor both ways of identifying a child account.
    const aaceCookie = decodeURIComponent(getCookieCore(cookieString, "aace" /* AuthCookieExistsCookieName.AppAnonCookieExists */));
    const { child } = (aaceCookie && tryParseJson(aaceCookie)) || {};
    const childCookie = getCookieCore(cookieString, childCookieName);
    if (aaceCookie && (child === 1 || childCookie)) {
        audienceMode = "kids" /* AudienceModeType.Kids */;
    }
    else {
        // When audience mode is not present in the modes object, we default to checking audienceMode property directly.
        audienceMode = clientSettings.modes?.audienceMode || clientSettings.audienceMode || "adult" /* AudienceModeType.Adult */;
    }
    return audienceMode;
}
//# sourceMappingURL=AudienceModeCookie.js.map